require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./crafting-impactful-resumes.json") })
        }
      }, "path---crafting-impactful-resumes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---crafting-impactful-resumes!./.cache/json/crafting-impactful-resumes.json
// module id = 1061
// module chunks = 231608221292675